import React, { useState } from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../../Enums/Size.enum';
import LaboratoryRequestTemplateEdit from './LaboratoryRequestTemplateEdit';
import { LaboratoryRequisitionTemplate } from '../../../../../graphql/graphql';

interface Props extends BaseModalProps {
	item: LaboratoryRequisitionTemplate;
	onUpdate: (item: LaboratoryRequisitionTemplate) => void;
	workplaceId: string;
}

const LaboratoryRequestTemplateEditModal: React.FC<Props> = props => {
	const [modalSize, setModalSize] = useState<Size>(Size.FULLSCREEN);

	return (
		<BaseModal
			{...props}
			title='component.laboratoryRequestTemplateEdit.modalTitle'
			size={modalSize}>
			<LaboratoryRequestTemplateEdit
				changeModalSize={size => setModalSize(size)}
				onUpdate={props.onUpdate}
				item={props.item}
				workplaceId={props.workplaceId}
			/>
		</BaseModal>
	);
};

export default LaboratoryRequestTemplateEditModal;
